module.exports = __webpack_public_path__ + "images/175_160.jpg";